<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <component :is="Component" ref="currentPage" />
    </router-view>
    <warnings ref="warnings" />
  </div>
</template>

<script>
import Warnings from './components/Warnings.vue'

export default {
  name: 'App',
  components: {
    Warnings
  }
}
</script>
